import React from 'react';

/** Consistent brand mark: "AgentPopulation" set in the serif, with the domain in mono. */
export function Wordmark({
  showDomain = true
}: {
  showDomain?: boolean;
}) {
  return <span className="inline-flex items-baseline gap-2.5" data-id="element-456" data-mp="2t0059n46lj0c">
      <span className="font-serif text-xl tracking-tight text-ink" data-id="element-457" data-mp="2szgyn2jzeh1m">
        Agent<span className="text-machine" data-id="element-458" data-mp="2ozq2ejbor8pp">Population</span>
      </span>
      {showDomain && <span className="hidden font-mono text-[10.5px] text-muted sm:inline lg:hidden xl:inline" data-id="element-459" data-mp="218khvqusvs92">agentpopulation.com</span>}
    </span>;
}